export const PatientSearch = "PatientSearch";
export const PatientSearchField = "PatientSearchField";
export const PatientSearchFieldClearButton = `${PatientSearchField}__ClearButton`;
export const PatientSearchFieldInput = `${PatientSearchField}__Input`;
export const PatientSearchFieldInputIcon = `${PatientSearchFieldInput}__Icon`;
